<template>
    <PopupRouterView :showLeftIcon="true" label="Control Card Log Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="controlcardlog"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="controlCardLogInput">


        <b-card header="Control Card Log" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="ControlCard" id="fieldset-control-card" size="sm" :model.sync="model.controlCardId" :isRequired="true" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards"   :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCard" />
						<app-input-textbox id="fieldset-transaction-type" label-cols-lg="12"  label="Transaction Type" label-for="input-transaction-type" size="sm" :model.sync="model.transactionType"   />
						<app-input-textbox id="fieldset-transaction" label-cols-lg="12"  label="TransactionId" label-for="input-transaction" size="sm" :model.sync="model.transaction"   />
						<app-input-textbox id="fieldset-qty-before" label-cols-lg="12"  label="Qty Before" label-for="input-qty-before" size="sm" :model.sync="model.qtyBefore"   />
						<app-input-textbox id="fieldset-qty-after" label-cols-lg="12"  label="Qty After" label-for="input-qty-after" size="sm" :model.sync="model.qtyAfter"   />
						<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Area Before" id="fieldset-area-before" size="sm" :model.sync="model.areaBeforeId"   :selected="model.areaBefore != null ? model.areaBefore.code : ''" @input="getAreas"   :isSelectMethodExists="true" @onSelectMethod="setSelectedAreaBefore" />
						<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Area After" id="fieldset-area-after" size="sm" :model.sync="model.areaAfterId"   :selected="model.areaAfter != null ? model.areaAfter.code : ''" @input="getAreas"   :isSelectMethodExists="true" @onSelectMethod="setSelectedAreaAfter" />
						<app-input-combobox-autocomplete :options="racks" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Rack Before" id="fieldset-rack-before" size="sm" :model.sync="model.rackBeforeId"   :selected="model.rackBefore != null ? model.rackBefore.code : ''" @input="getRacks"   :isSelectMethodExists="true" @onSelectMethod="setSelectedRackBefore" />
						<app-input-combobox-autocomplete :options="racks" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Rack After" id="fieldset-rack-after" size="sm" :model.sync="model.rackAfterId"   :selected="model.rackAfter != null ? model.rackAfter.code : ''" @input="getRacks"   :isSelectMethodExists="true" @onSelectMethod="setSelectedRackAfter" />
						<app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Control Card Status" id="fieldset-control-card-status" size="sm" :model.sync="model.controlCardStatusId"   :selected="model.controlCardStatus != null ? model.controlCardStatus.name : ''" @input="getControlCardStatuss"   :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCardStatus" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ControlCardLog from '@/models/ControlCardLog/ControlCardLog';
import ControlCardLogList from '@/models/ControlCardLog/ControlCardLogList';
import ControlCardLogFilter from '@/filters/ControlCardLog/ControlCardLogFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import Area from '@/models/Area/Area';
import AreaFilter from '@/filters/Area/AreaFilter';
import Rack from '@/models/Rack/Rack';
import RackFilter from '@/filters/Rack/RackFilter';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			controlCardId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				controlCardId: { required : "ControlCard is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterControlCardLog : null,
			currentControlCardLogPage : 1,
			controlCardLogPageSize: 10,
			sortByControlCardLog: '',
			sortDescControlCardLog: '',
			controlCards: [],
			controlCards: [],
			isControlCardComboLoading: false,
			areas: [],
			areaBefores: [],
			isAreaBeforeComboLoading: false,
			racks: [],
			rackBefores: [],
			isRackBeforeComboLoading: false,
			controlCardStatuss: [],
			controlCardStatuss: [],
			isControlCardStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isControlCardComboLoading: false,
			isAreaComboLoading: false,
			isRackComboLoading: false,
			isControlCardStatusComboLoading: false,
		}
	},
	methods : {
		getControlCardLog : async function(id) {
			this.isBusy = true;
			ControlCardLog.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadControlCardLog = true;
			this.filterControlCardLog.id = this.modelId;
			ControlCardLog.downloadDataDetail(this, this.filterControlCardLog).then(result => {
				this.isDownloadControlCardLog = false;
			}).catch(error => { this.isDownloadControlCardLog = false; })
		},
		getControlCardLogs : async function(input) {
			let filter = new ControlCardLogFilter();
			if (input != undefined) {
				filter.ControlCard = input;
			}
			this.isControlCardLogComboLoading = true;
			ControlCardLog.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardLogs = result.data
				}
				this.isControlCardLogComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCard(item) {
			if(item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedAreaBefore(item) {
			if(item == undefined || item == null) {
				this.model.areaBeforeId = null;
				this.model.areaBefore = null;
			} else {
				this.model.areaBeforeId = item.id;
				this.model.areaBefore = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedAreaAfter(item) {
			if(item == undefined || item == null) {
				this.model.areaAfterId = null;
				this.model.areaAfter = null;
			} else {
				this.model.areaAfterId = item.id;
				this.model.areaAfter = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getRacks : async function(input) {
			let filter = new RackFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Rack.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.racks = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedRackBefore(item) {
			if(item == undefined || item == null) {
				this.model.rackBeforeId = null;
				this.model.rackBefore = null;
			} else {
				this.model.rackBeforeId = item.id;
				this.model.rackBefore = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedRackAfter(item) {
			if(item == undefined || item == null) {
				this.model.rackAfterId = null;
				this.model.rackAfter = null;
			} else {
				this.model.rackAfterId = item.id;
				this.model.rackAfter = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getControlCardStatuss : async function(input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ControlCardStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCardStatus(item) {
			if(item == undefined || item == null) {
				this.model.controlCardStatusId = null;
				this.model.controlCardStatus = null;
			} else {
				this.model.controlCardStatusId = item.id;
				this.model.controlCardStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.controlCardLogInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						ControlCardLog.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'controlcardlogindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						ControlCardLog.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'controlcardlogindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ControlCardLog.updateData(this, model, id)
					.catch((error) => {
						this.getControlCardLog(id);
					});
				}
			});
		},
		onHidden() {
			this.getControlCardLogs();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterControlCardLog = new ControlCardLogFilter();
		//this.getControlCards();
		//this.getAreas();
		//this.getRacks();
		//this.getControlCardStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getControlCardLog(id);
			} else {
				this.modelId = id;
				this.getControlCardLog(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
